import { render, staticRenderFns } from "./NotificationFundraisingRewardPurchased.vue?vue&type=template&id=004de874&scoped=true&"
import script from "./NotificationFundraisingRewardPurchased.vue?vue&type=script&lang=ts&"
export * from "./NotificationFundraisingRewardPurchased.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004de874",
  null
  
)

export default component.exports